import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { isServer } from 'Utils/envUtils';

import rootReducer from 'Reducers/rootReducer';

export let store: any = {};

export const configureStore = (preloadedState: any) => {
	if (isServer()) {
		store = createStore(
			rootReducer,
			preloadedState,
			applyMiddleware(thunkMiddleware),
		);

		return store;
	}
	/*
 Instead of window.devToolsExtension (which was planned to be deprecated in
 favour of window.__REDUX_DEVTOOLS_EXTENSION__),
 now we’ll be using window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
 */
	/* eslint-disable no-underscore-dangle */
	// process.env.NODE_ENV !== 'production'
	const composeEnhancers =
		typeof window === 'object' &&
		(window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
			? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
			: compose;

	store = createStore(
		rootReducer,
		preloadedState,
		composeEnhancers(applyMiddleware(thunkMiddleware)),
	);

	return store;
};
